import React from 'react';
import { useHistory } from 'react-router-dom';
import A from '../../../../../common/A';

function Header({ handleTab, tabValue }) {
  const history = useHistory();
  
  const handleClose = () => {
    history.goBack();
  };

  return (
    <div className="header bg_white">
      <div className="inner">
        <div className="headerBox center">
          <div className="w1280">
            <div className="headerBox_head">
              <h1 className="tit">학습노트</h1>
              <button className="btn-close-wrap" onClick={handleClose} />
            </div>
          </div>
        </div>
        <div className="header_tab2">
          <ul className="tablist cls">
            <li><A className={tabValue === 'learning' ? "active" : ''} onClick={() => handleTab('learning')}>학습</A></li>
            <li><A className={tabValue === 'diagnosis' ? "active" : ''} onClick={() => handleTab('diagnosis')}>진단</A></li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Header;